import { render, staticRenderFns } from "./SquareBanner.vue?vue&type=template&id=78fd622e&"
import script from "./SquareBanner.vue?vue&type=script&lang=js&"
export * from "./SquareBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports